import React from 'react';
import PropTypes from 'prop-types';

import RenderRichText from 'utils/richText/renderRichText';

import { StyledAirfieldInformationWrapper, StyledInformationColumn } from 'components/airfield/styled';

function InformationSection({ columns, sectionHeading, preview }) {
  return (
    <StyledAirfieldInformationWrapper>
      <section className="information-section-heading">
        <RenderRichText 
          richTextArray={ preview ? sectionHeading : sectionHeading.raw }
        />

      </section>
      {columns.map(el => {
        return (
          <StyledInformationColumn>
            <RenderRichText 
              richTextArray={preview ? el.column : el.column.raw }
            />
          </StyledInformationColumn>
        )
      })}
    </StyledAirfieldInformationWrapper>
  )
}

InformationSection.propTypes = {
  columns: PropTypes.array,
  preview: PropTypes.bool,
  sectionHeading: PropTypes.object
};

export default InformationSection;
